import store from "@/store";

/**
 * Setores com janelas só oferecem as operações que têm horário cadastrado
 * (mapa vindo do report de setores). Sem informação, libera as duas.
 */
export const operacaoDisponivel = (setorUkey: unknown, operacao: 1 | 2) => {
  const ops = store.state.setores_operacoes[String(setorUkey ?? "")];

  if (!ops) {
    return true;
  }

  return operacao == 1 ? ops.carregar : ops.descarregar;
};

export const itensOperacao = (setorUkey: unknown) => [
  {
    name: "Carregar",
    value: 1,
    icon: "arrow-up",
    disabled: !operacaoDisponivel(setorUkey, 1),
    disabledTitle: "Este setor não possui horários para carregamento.",
  },
  {
    name: "Descarregar",
    value: 2,
    icon: "arrow-down",
    disabled: !operacaoDisponivel(setorUkey, 2),
    disabledTitle: "Este setor não possui horários para descarga.",
  },
];
